import FRCallback from './index.js';

/*
 * @forgerock/javascript-sdk
 *
 * validated-create-password-callback.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * Represents a callback used to collect a valid platform password.
 */
class ValidatedCreatePasswordCallback extends FRCallback {
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the callback's failed policies.
     */
    getFailedPolicies() {
        const failedPolicies = this.getOutputByName('failedPolicies', []);
        try {
            return failedPolicies.map((v) => JSON.parse(v));
        }
        catch (err) {
            throw new Error('Unable to parse "failed policies" from the ForgeRock server. The JSON within `ValidatedCreatePasswordCallback` was either malformed or missing.');
        }
    }
    /**
     * Gets the callback's applicable policies.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPolicies() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.getOutputByName('policies', {});
    }
    /**
     * Gets the callback's prompt.
     */
    getPrompt() {
        return this.getOutputByName('prompt', '');
    }
    /**
     * Gets whether the password is required.
     */
    isRequired() {
        return this.getOutputByName('required', false);
    }
    /**
     * Sets the callback's password.
     */
    setPassword(password) {
        this.setInputValue(password);
    }
    /**
     * Set if validating value only.
     */
    setValidateOnly(value) {
        this.setInputValue(value, /validateOnly/);
    }
}

export { ValidatedCreatePasswordCallback as default };
